import { CurrencyPipe} from '@angular/common';
import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[wfdssCurrencyFormat]',
    standalone: false
})
export class CurrencyFormatDirective {

  private currencyPipe = new CurrencyPipe('en-US');

  constructor(private el: ElementRef) { }

  @HostListener('blur') onBlur() {
    this.formatValue();
  }

  @HostListener('focus', ['$event.target.value']) onFocus(value: string) {
    this.parseValue(value);
  }

  @HostListener('input', ['$event.target.value']) onInput(value: string) {
    this.parseValue(value);
  }

  private formatValue() {
    let value = this.el.nativeElement.value.replace(/[^0-9]/g, '');
    value = parseInt(value, 10);
    this.el.nativeElement.value = this.formatNumber(value);
  }

  private parseValue(value: string) {
    const number = parseInt(value.replace(/[^0-9]/g, ''), 10);
    this.el.nativeElement.value = this.formatNumber(number);

  }

  private formatNumber(value: number): string {
    if (isNaN(value)) {
      return '';
    }
    return this.currencyPipe.transform(value, 'USD', 'symbol', '1.0-0') || ''
  }
}